/**
 * Returns the Authorization header for API calls, reading the JWT that the
 * login flow stores in localStorage under 'token'. Returns {} when not logged
 * in (or outside the browser), so it is safe to spread into any fetch headers.
 */
export function getAuthHeaders(): Record<string, string> {
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}
